import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "input",
    "dropZone",
    "progressArea",
    "filename",
    "filesize",
    "status",
    "spinner",
  ];

  connect() {
    this.boundHandleDragOver = this.handleDragOver.bind(this);
    this.boundHandleDragLeave = this.handleDragLeave.bind(this);
    this.boundHandleDrop = this.handleDrop.bind(this);
  }

  handleClick(event) {
    event.preventDefault();
    this.inputTarget.click();
  }

  handleFileSelect(event) {
    const files = event.target.files;
    if (files.length > 0) {
      this.processFiles(files);
    }
  }

  handleDragOver(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dropZoneTarget.classList.add("drag-over");
  }

  handleDragEnter(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dropZoneTarget.classList.add("drag-over");
  }

  handleDragLeave(event) {
    event.preventDefault();
    event.stopPropagation();

    // ドロップゾーンから完全に離れた場合のみクラスを削除
    if (!this.dropZoneTarget.contains(event.relatedTarget)) {
      this.dropZoneTarget.classList.remove("drag-over");
    }
  }

  handleDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    this.dropZoneTarget.classList.remove("drag-over");

    const files = event.dataTransfer.files;
    if (files.length > 0) {
      this.processFiles(files);
    }
  }

  processFiles(files) {
    const file = files[0];
    this.uploadFile(file);
  }

  uploadFile(file) {
    this.showProgressUI(file);

    const formData = new FormData();
    formData.append("resume", file);

    fetch("/mypage/resumes", {
      method: "POST",
      body: formData,
      headers: {
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
    })
      .then((response) => {
        if (response.ok) {
          this.updateStatus("アップロード完了");
          this.hideSpinner();
          window.location.reload();
        } else {
          response
            .json()
            .then((data) => {
              this.showError(data.error || "エラーが発生しました");
            })
            .catch(() => {
              this.showError("エラーが発生しました");
            });
        }
      })
      .catch(() => {
        this.showError("エラーが発生しました");
      });
  }

  showProgressUI(file) {
    this.dropZoneTarget.style.display = "none";
    this.progressAreaTarget.style.display = "block";

    this.filenameTarget.textContent = file.name;
    this.filesizeTarget.textContent = this.formatFileSize(file.size);
    this.statusTarget.textContent = "AI処理中...";
  }

  updateStatus(status) {
    this.statusTarget.textContent = status;
  }

  hideSpinner() {
    this.spinnerTarget.style.display = "none";
  }

  showError(message) {
    this.hideSpinner();
    this.progressAreaTarget.style.display = "none";
    this.dropZoneTarget.style.display = "";

    const notesEl = document.querySelector(
      ".mypage-profile-upload-pc-section__notes",
    );
    if (notesEl) {
      const existing = notesEl.parentElement.querySelector(
        ".mypage-profile-upload-pc-section__error",
      );
      if (existing) existing.remove();

      const errorEl = document.createElement("p");
      errorEl.className = "mypage-profile-upload-pc-section__error";
      errorEl.textContent = message;
      notesEl.insertAdjacentElement("afterend", errorEl);
    }
  }

  formatFileSize(bytes) {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + sizes[i];
  }
}
